import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (requestError) {
      setError(formatApiError(requestError.response?.data?.detail) || requestError.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="mx-auto flex min-h-[calc(100vh-4rem)] max-w-xl items-center px-6 py-16">
      <form onSubmit={submit} className="w-full rounded-2xl border border-neutral-200 bg-white p-7" data-testid="forgot-password-form">
        <p className="eyebrow mb-2">Account recovery</p>
        <h1 className="font-display text-3xl font-bold tracking-tight">Reset your password</h1>
        <p className="mt-3 text-sm leading-relaxed text-neutral-500">
          Enter your email and we’ll send a one-time link to choose a new password.
        </p>
        {sent ? (
          <div className="mt-6 rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-900" data-testid="forgot-password-success">
            If an account exists for that email, a reset link has been sent.
          </div>
        ) : (
          <>
            {error && <p className="mt-5 text-sm text-red-600" data-testid="forgot-password-error">{error}</p>}
            <div className="mt-6">
              <Label htmlFor="forgot-email">Email address</Label>
              <Input
                id="forgot-email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
                className="mt-1"
                data-testid="forgot-password-email"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="mt-6 w-full rounded-full bg-[hsl(var(--primary))]"
              data-testid="forgot-password-submit"
            >
              {loading ? "Sending…" : "Email reset link"}
            </Button>
          </>
        )}
        <Link to="/login" className="mt-6 inline-block text-sm font-medium text-[hsl(var(--primary))]" data-testid="forgot-password-back-login">
          Back to sign in
        </Link>
      </form>
    </main>
  );
}